/** @format */

import React from "react";

const LinkSection = () => {
  return (
    <div className="Link_Section">
      <a
        href="https://www.instagram.com"
        target="_blank"
        rel="noreferrer"
      >
        <img src="./Image/26.png" alt="" />
      </a>
      <a
        href="https://www.facebook.com"
        target="_blank"
        rel="noreferrer"
      >
        <img src="./Image/27.png" alt="" />
      </a>
      <a
        href="https://www.twitter.com"
        target="_blank"
        rel="noreferrer"
      >
        <img src="./Image/28.png" alt="" />
      </a>
      <a
        href="https://www.linkedin.com"
        target="_blank"
        rel="noreferrer"
      >
        <img src="./Image/29.png" alt="" />
      </a>
      <a
        href="https://www.whatsapp.com"
        target="_blank"
        rel="noreferrer"
      >
        <img src="./Image/30.png" alt="" />
      </a>
    </div>
  );
};

export default LinkSection;
